/** آدرس اصلی بک‌اند (بدون /api). مثل project-manager و contracts: روی ساب‌دامین از دامنهٔ اصلی استفاده می‌شود، وگرنه از .env (VITE_BACKEND_URL). در توسعهٔ محلی اگر ست نشده باشد به localhost:8000 می‌رود. */
const PRODUCTION_FRONTEND_HOSTS = new Set([
  'costing.darvagco.ir',
  'project-analysis.darvagco.ir',
]);

export function getBackendBaseUrl(): string {
  if (typeof window !== 'undefined' && PRODUCTION_FRONTEND_HOSTS.has(window.location.hostname)) {
    return 'https://darvagco.ir';
  }
  const url = import.meta.env.VITE_BACKEND_URL;
  if (url) return String(url).replace(/\/$/, '');
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:8000';
  }
  return '';
}

export function getApiBase(): string {
  const base = getBackendBaseUrl();
  return base ? `${base}/api/panel/project-analysis` : '/api/panel/project-analysis';
}
